import { render, staticRenderFns } from "./recordInfo.vue?vue&type=template&id=69e81663&"
import script from "./recordInfo.vue?vue&type=script&lang=js&"
export * from "./recordInfo.vue?vue&type=script&lang=js&"
import style0 from "./recordInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports